<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="gatewayFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#gatewayFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                    <kt-form-section >
                        <kt-form-row>
                            <kt-col xs="12" sm="4" md="3">
                                <kt-form-group>
                                    <kt-form-label for="gateway_status">
                                        {{ $t('label.gateway_status') }}
                                    </kt-form-label>
                                    <kt-form-select
                                            size="3"
                                            id="gateway_status"
                                            class="form-control"
                                            name="gateway_status"
                                            v-model="query.gateway_status"
                                    >
                                        <option
                                                v-bind:key="index"
                                                v-for="(gateway_status, index) in gateway_statuses"
                                                v-bind:value="gateway_status.value"
                                                :selected="query.gateway_status === gateway_status.value"
                                        >
                                            {{ gateway_status.name ? gateway_status.name :  $t('gateway_status.all') }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="5" md="3">
                                <kt-form-group>
                                    <kt-form-label for="farsi_name">
                                        {{ $t('label.gateway_title') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="farsi_name"
                                            name="farsi_name"
                                            id="farsi_name"
                                            v-model="query.farsi_name"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="5" md="3">
                                <kt-form-group>
                                    <kt-form-label for="terminal_number">
                                        {{ $t('label.terminal_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="terminal_number"
                                            name="terminal_number"
                                            id="terminal_number"
                                            v-model="query.terminal_number"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="3" md="3" style="margin-top: 25px;text-align: left">
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import {gatewayStatus, statuses} from '@/constants/gatewayStatus'
import {subcategories} from '@/constants/subcategoriesForSearch'
import $ from "jquery";
import { i18n } from '@/plugins/i18n'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    data() {
        return {
            subcategories: subcategories,
            gateway_statuses: statuses,
            query: {
                gateway_status: gatewayStatus.ACTIVE
            },
        }
    }
}
</script>

<style>

</style>